import BaseAgencyScopeEntityDto from '@/models/Shared/BaseAgencyScopeEntityDto';
import UserDto from '@/models/Users/UserDto';
import EntityType from '@/models/Shared/EntityType';
import GeneralStatus from '@/models/Shared/GeneralStatus';

export default class DocumentDto extends BaseAgencyScopeEntityDto {
    createdBy: UserDto = new UserDto();
    lastUpdatedBy: UserDto = new UserDto();
    entityId = '';
    entityType: EntityType
    status: GeneralStatus = GeneralStatus.ActiveOrApproved;
    name = '';
    extension = '';
    contentType = '';
    isExpiryTracked = false;
    expiresAt: Date = new Date();
}